import { render, staticRenderFns } from "./SpFormArrangement.vue?vue&type=template&id=4971961b&"
import script from "./SpFormArrangement.vue?vue&type=script&lang=js&"
export * from "./SpFormArrangement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports